type PropTypes = {
  className?: string
}

const EllipsisIcon = ({ className }: PropTypes) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      className={className}
    >
      <path fill="currentColor" d="M11.25 15a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0ZM11.25 10a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0ZM11.25 5a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0Z" />
    </svg>
  )
}

export default EllipsisIcon
